import { FC, ReactNode } from 'react';
import { QueryOptions, QueryResult, WatchQueryFetchPolicy } from '@apollo/client';
import { Query } from '@apollo/client/react/components';
import LoadingBar from './LoadingBar';

interface WrappedQueryProps extends Omit<QueryOptions, 'fetchPolicy'> {
  children: (result: QueryResult) => any;
  loader?: ReactNode;
  overrideStates?: boolean;
  skip?: boolean;
  // This renders a <Query>, which is a watch query — so it takes the wider policy set, including
  // cache-and-network. QueryOptions.fetchPolicy is the narrower one-shot client.query() type.
  fetchPolicy?: WatchQueryFetchPolicy;
}

/**
 * @render react
 * @name WrappedQuery component
 * @description WrappedQuery component.
 * @example
 * <WrappedQuery />
 */
const WrappedQuery: FC<WrappedQueryProps> = ({ children, ...rest }) => {
  return (
    <Query {...rest}>
      {(result: QueryResult) => {
        if (!rest.overrideStates) {
          if (result.loading) {
            return rest.loader;
          }
          if (result.error) {
            return <span>{`Error!: ${result.error}`}</span>;
          }
        }

        return children(result);
      }}
    </Query>
  );
};

WrappedQuery.defaultProps = {
  loader: <LoadingBar />,
  overrideStates: false,
};

export default WrappedQuery;
